/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { Token } from "../../store/global/TokenEnum";
import { Amount } from "../../types/amount";
import { FlexContainer } from "../../containers/FlexContainer";
import { DetailsRightColumnText } from "./elements/DetailsRightColumnText";
import styled from "@emotion/styled";

/**
 *
 * We can probably have something smarter which checks number of decimals of the USD price,
 * this is specifically for values where only 1 token doesn't yield a great exchange and
 * so if we truncate the exchange rate to 5dp then you get 0.0000.
 */
export const ExchangeRate: React.FC<{
  symbol: Token;
  oppositeSymbol: Token;
  price: Amount;
  flippedPrice: Amount;
}> = ({ symbol, oppositeSymbol, price, flippedPrice }) => {
  const [switchRate, setSwitchRate] = useState(false);

  return (
    <FlexContainer>
      <Row onClick={() => setSwitchRate(!switchRate)}>
        {switchRate ? (
          <DetailsRightColumnText>
            1 {symbol} = {flippedPrice.format(5)} {oppositeSymbol}
          </DetailsRightColumnText>
        ) : (
          <DetailsRightColumnText>
            1 {oppositeSymbol} = {price.format(5)} {symbol}
          </DetailsRightColumnText>
        )}
      </Row>
    </FlexContainer>
  );
};

// Sub-components

const Row = styled.button``;
